var configManager = require('../../../config/configManager'),
  CONST_ACTIONCODES = require('../../../constants/actionCodes'),
  base64Url = require('sixtyfour'),
  responseMapper = require('../../../utilities/responseMapper'),
  Payment = require('../../payment');

function ErrorResponse(errorNumber, errorDescription, paymentType, rawJwt) {
  var suppressValues = configManager.getFeatureFlags().EnabledSuppressedPaymentsValidatedResponse;  
  if(!suppressValues){
    this.Validated = false;
    this.ActionCode = CONST_ACTIONCODES.ERROR;
  }

  if (paymentType !== undefined) {
    this.Payment = new Payment(paymentType);
  }
  
  this.ErrorNumber = errorNumber;
  this.ErrorDescription = errorDescription;
  this.rawJwt = rawJwt;
}

ErrorResponse.prototype = new Error();
ErrorResponse.prototype.name = "ErrorResponse";
ErrorResponse.prototype.constructor = ErrorResponse;

ErrorResponse.prototype.parseError = function parseError(decodedResponse) {
  if (decodedResponse && decodedResponse.Payload) {
    if (decodedResponse.Payload.ValidateResponse) {
      var jwt = decodedResponse.Payload.ValidateResponse,
        jwtParts = (jwt ? jwt.split('.') : []),
        encPayload = (jwtParts.length > 1 ? jwtParts[1] : false);

      this.originalJwt = decodedResponse.Payload.ValidateResponse;

      if (encPayload) {
        var parsedJSON = base64Url.decodeJson(encPayload);
        if (parsedJSON) {
          decodedResponse = parsedJSON;
        }
      }
    }

    if (typeof decodedResponse.Payload === 'string') {
      decodedResponse.Payload = JSON.parse(decodedResponse.Payload);
    }

    this.Validated = decodedResponse.Payload.Validated || false;
    this.ActionCode = decodedResponse.Payload.ActionCode || CONST_ACTIONCODES.ERROR;
    this.ErrorNumber = decodedResponse.Payload.ErrorNumber;
    this.ErrorDescription = decodedResponse.Payload.ErrorDescription;

    if (decodedResponse.Payload.Payment) {
      this.Payment = decodedResponse.Payload.Payment;
    }
    if (decodedResponse.Payload.Token) {
      this.Token = decodedResponse.Payload.Token;
    }
    if (decodedResponse.Payload.Risk) {
      this.Risk = decodedResponse.Payload.Risk;
    }
    if (decodedResponse.Payload.Authorize) {
      this.Authorize = decodedResponse.Payload.Authorize;
    }
    if (decodedResponse.Payload.AuthorizationProcessor) {
      this.AuthorizationProcessor = decodedResponse.Payload.AuthorizationProcessor;
    }
    if (decodedResponse.Payload.CCA) {
      this.Payment = responseMapper.map.payment.from.cca(decodedResponse.Payload.CCA);
    }
  }

};

module.exports = ErrorResponse;



//////////////////
// WEBPACK FOOTER
// ./models/errors/midas/errorResponse.js
// module id = 34
// module chunks = 0 5 20